//ACCORDION VERSION
$('.faq__question').click(function () {
    let faq = this.closest('.faq');
    let faqsContainer = this.closest('.faqs');

    if(!faq.classList.contains('active')){
        $(faqsContainer).find('.faq').removeClass('active');
    }
    faq.classList.toggle('active');
});

//OPEN IN MODAL VERSION
// $('.faq').click(function () {
//     let answer = this.querySelector('.faq__answer').innerHTML;
//     let question = this.querySelector('.faq__question').innerHTML;
//     let modal = new tingle.modal({
//         closeLabel: '',
//         cssClass: ['modal-faq'],
//         onClose(){
//             modal.destroy();
//         },
//     });
//     modal.setContent(`
//         <h2 class="modal-faq__question">${question}</h2>
//         <div class="modal-faq__answer">${answer}</div>
//     `);
//     modal.open();
// });